import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { resetCounter } from '@app/actions/scenes/counter'
import {
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import AdjustDuration
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MezzoActions/MezzoLightsActions/AdjustDurationBrightness/AdjustDuration'
import AdjustDurationIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MezzoActions/MezzoLightsActions/AdjustDurationBrightness/AdjustDuration'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(AdjustDurationIOS) : withStyles(AdjustDuration)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { counter: counterInfo } = state.scenes
  const { durationValueAfter, stateDescription } = state.scenes.currentSceneCreating.currentAction
  return {
    isMobile,
    path,
    counterInfo,
    durationValueAfter,
    stateDescription,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  resetCounter,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const AdjustDurationEnhanced = enhance

export default withRouter(AdjustDurationEnhanced)
